<div class="part2">

    <div class="row titles-div" data-aos="fade-left">
        <div class="col-3 title">
            <label>איך משחקים יחד, בנפרד?</label>
        </div>
        <div class="col-3 title">
            <label>למי זה מתאים?</label>
        </div>
        <div class="col-3 title">
            <label>מה מיוחד במשחק אונליין?</label>
        </div>
        <div class="col-3 title">
            <label>הזמינו כבר עכשיו!</label>
        </div>
    </div>

    <div class="row content-txt" >
        <label class="txt-1" data-aos="fade-up-left">
            מה זה בכלל מלחמת מוחות אונליין?
        </label>

        <p class="txt-2" data-aos="fade-up-left">
            לקחנו את הגיבוש והחוויה שיש במשחק טריוויה קבוצתי,
            <br>
             שילבנו עם הפורמט הדיגיטלי של קוויזים, סקרים ושאלונים
             <br>
            וחיברנו יחד למשחק טריוויה אונליין מאתגר במיוחד!
        </p>

        <img class="message-icn" [src]="baseURL + 'message-icn.png'">

        <p class="txt-3" data-aos="fade-up-left">
            משחק הטריוויה וירטואלי ומורכב משאלות מאתגרות ומרתקות.
            <br>
            בנוסף, אפשרי להציג תמונות וסרטונים לפני/אחרי השאלה.       
        </p>

        <p class="txt-4" data-aos="fade-up-left">
            בטריוויה תוכלו לשלב שאלות בהתאמה אישית, אותן אתם כותבים,
            <br> 
            יחד עם תוכן מהמאגר שלנו המכיל מעל K10 שאלות בנושאים שונים          
        </p>

        <span class="txt-5" data-aos="fade-up-left">וכך זה נראה:</span>
        <img  class="arrow-icn" [src]="baseURL + 'arrow-icn.png'">
    </div>

</div>